document.addEventListener('click', function (e) {

  const button = e.target.closest('[data-qty]');

  if (!button) return;


  const wrapper = button.closest('[data-quantity]');

  if (!wrapper) return;


  const input = wrapper.querySelector('input');

  if (!input) return;


  const minimum = parseInt(
    input.min || 1,
    10
  );


  const step = parseInt(
    input.step || 1,
    10
  );


  let value = parseInt(
    input.value || minimum,
    10
  );


  if (button.dataset.qty === 'plus') {

    value += step;

  } else {

    value = Math.max(
      minimum,
      value - step
    );

  }


  input.value = value;


  input.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );

});



/*
  Product tabs
*/

document.querySelectorAll('[data-tabs]').forEach(function (tabs) {

  tabs.querySelectorAll('[data-tab]').forEach(function (button) {

    button.addEventListener('click', function () {

      tabs
        .querySelectorAll('[data-tab], [data-panel]')
        .forEach(function (element) {
          element.classList.remove('active');
        });


      button.classList.add('active');


      const panel =
        tabs.querySelector(
          '[data-panel="' +
          button.dataset.tab +
          '"]'
        );


      if (panel) {
        panel.classList.add('active');
      }
      
      document.addEventListener('click', function(event) {
  const nav = document.querySelector('.nav');
  const toggle = document.querySelector('.mobile-toggle');
  
  if (!nav.contains(event.target) && !toggle.contains(event.target) && document.body.classList.contains('menu-open')) {
    document.body.classList.remove('menu-open');
  }
});

    });

  });

});